// BreakdownGroupModal üye listesi (Modal.dc.html "Alt kalemler"): satır başına ad + "Katalogdan seç"
// (grubun sette olmayan katalog üyeleri) + sil; "+ Üye". Ad yazılınca katalog seçimi bırakılır
// (yeni üye); katalogdan seçilince ad katalog etiketi olur. Durum üst bileşende (GroupForm).

import { KPI_BREAKDOWN_COPY } from "../../lib/kpi-breakdown-copy";
import { newMemberDraft, type MemberDraft } from "../../lib/kpi-breakdown-group-form";
import { btnGhost, inputStyle, labelStyle } from "./kpi-form-styles";

export interface CatalogMemberOption {
  metricId: string;
  label: string;
}

export function BreakdownGroupMembers(props: {
  members: readonly MemberDraft[];
  catalog: readonly CatalogMemberOption[];
  existing: readonly string[];
  disabled: boolean;
  onChange: (members: MemberDraft[]) => void;
}): JSX.Element {
  const C = KPI_BREAKDOWN_COPY.modal;
  const { members, catalog, existing, disabled, onChange } = props;
  const taken = new Set(members.map((m) => m.metricId).filter((x): x is string => x !== null));
  const patch = (key: string, next: Partial<MemberDraft>): void =>
    onChange(members.map((m) => (m.key === key ? { ...m, ...next } : m)));
  return (
    <div>
      <span style={labelStyle}>{C.members}</span>
      {existing.length > 0 ? (
        <div className="text-sm" style={{ color: "var(--color-text-3)", margin: "4px 0 8px" }}>
          {C.existingMembers(existing.join(", "))}
        </div>
      ) : null}
      <div className="grid gap-2" style={{ marginTop: 6 }}>
        {members.map((m) => {
          const options = catalog.filter(
            (o) => o.metricId === m.metricId || !taken.has(o.metricId),
          );
          return (
            <div
              key={m.key}
              data-testid="kpi-breakdown-member-row"
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(0, 1fr) 180px 44px",
                gap: 8,
                alignItems: "center",
              }}
            >
              <input
                style={inputStyle}
                aria-label={C.memberName}
                placeholder={C.memberPlaceholder}
                value={m.label}
                maxLength={200}
                disabled={disabled}
                onChange={(e) => patch(m.key, { label: e.target.value, metricId: null })}
              />
              <select
                style={{ ...inputStyle, minHeight: 44 }}
                aria-label={C.fromCatalog}
                title={options.length === 0 ? C.fromCatalogNone : C.fromCatalog}
                value={m.metricId ?? ""}
                disabled={disabled || options.length === 0}
                onChange={(e) => {
                  const hit = options.find((o) => o.metricId === e.target.value);
                  patch(
                    m.key,
                    hit ? { metricId: hit.metricId, label: hit.label } : { metricId: null },
                  );
                }}
              >
                <option value="">{C.fromCatalog}</option>
                {options.map((o) => (
                  <option key={o.metricId} value={o.metricId}>
                    {o.label}
                  </option>
                ))}
              </select>
              <button
                type="button"
                aria-label={C.removeMember(m.label.trim())}
                disabled={disabled || members.length <= 1}
                onClick={() => onChange(members.filter((x) => x.key !== m.key))}
                style={{
                  ...btnGhost,
                  border: 0,
                  minHeight: 44,
                  padding: 0,
                  color: "var(--color-text-3)",
                }}
              >
                🗑
              </button>
            </div>
          );
        })}
        <button
          type="button"
          style={{
            ...btnGhost,
            alignSelf: "flex-start",
            justifySelf: "start",
            minHeight: 44,
            color: "var(--color-primary)",
            borderColor: "var(--color-primary)",
            fontWeight: 600,
          }}
          disabled={disabled || members.length >= 50}
          onClick={() => onChange([...members, newMemberDraft()])}
        >
          {C.addMember}
        </button>
      </div>
    </div>
  );
}
